var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-label',{attrs:{"label":_vm.$t('payment.status.' + _vm.status),"icon":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }